const GET_CURRENT_USER = "frappe.auth.get_logged_user";
const PURCHASE_ORDER = "frappe.desk.query_report.run";
const EXEC_SAP_QUERY = 'dlad_sap_connector.dlad_sap_connector.api.execute_query';

export {GET_CURRENT_USER, PURCHASE_ORDER, EXEC_SAP_QUERY}